import { useTranslation } from 'react-i18next';

import RadixDialog from '../../../../shared/RadixDialog';
import SimpleDateForm from './SimpleDateForm.jsx';
import { useCampaignDateUpdate } from './useCampaignDateUpdate.js';

export default function DateEditModal({ isOpen, campaign, onClose }) {
  const { t } = useTranslation('campaigns');
  const { updateCampaignDates } = useCampaignDateUpdate();

  if (!campaign) {
    return null;
  }

  const handleDateUpdate = dates => {
    updateCampaignDates(campaign.uuid, dates);
    onClose();
  };

  return (
    <RadixDialog
      isOpen={isOpen}
      onClose={onClose}
      title={t('dateEditModal.title')}
    >
      <SimpleDateForm
        campaignStartDate={campaign.startDate}
        campaignEndDate={campaign.endDate}
        onSave={handleDateUpdate}
        onCancel={onClose}
      />
    </RadixDialog>
  );
}
